import React from 'react'
import Header from './header'
import { createGlobalStyle } from 'styled-components'
import Helmet from 'react-helmet'
import styled from 'styled-components'

const GlobalStyle = createGlobalStyle`
  html {box-sizing: border-box;}
  body {
    padding: 0;
    margin: 0;
    font-family: 'Open Sans', sans-serif;

    color: #131415;

    h1, h2, h3, h4, h5, h6 {
      margin:0; padding:0;
    }

    h1 {
      font-size: calc(1.8em + 1vw);
    }
    
    h2 {
      font-size: calc(1.3em + 1vw);
    }

    h3 {
      font-size: calc(1.2em + 1vw);
    }

    h4 {
      font-size: calc(1.1em + 1vw);
    }

    h5 {
      font-size: 1em;
    }

    figure {
      margin:0;
    }

    a {
      color: #94AE89;
    }
  }
  
  .layout {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }

  img, iframe {
    max-width: 100%;
  }

  .content {
    flex: 1;
    > .framed {
      padding-top: 70px;
      height: 100%;
    }
  }
`

const Footer = styled.div`
  border-top: 1px solid #dfdfdf;
  display: grid;
  grid-template-columns: minmax(30px, 60px) 1fr  minmax(30px, 60px);
  padding: 70px 0;

  > * {
    grid-column: 2;
  }
`

export default ({ children, onHideNav, onShowNav, showNav, siteTitle, scrollNav }) => (
  <>
    <Helmet>
    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;0,700;1,300&display=swap" rel="stylesheet"/>
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;0,600;1,400&display=swap" rel="stylesheet"/>
    </Helmet>
    <GlobalStyle />
    <div className="layout">
      <Header className="header" siteTitle={siteTitle} onHideNav={onHideNav} onShowNav={onShowNav} showNav={showNav} scrollNav={scrollNav} />
      <div className="content">{children}</div>
      <Footer >
        <div> © {new Date().getFullYear()} Gruppe B - TBT4850 Eksperter i team.</div>
    </Footer>
    </div>
  </>
)
